export default __webpack_public_path__ + "static/media/gable.ab2a8d90.png";